import moment from 'moment';

export function getDateFormatted(date = new Date()) {
    return moment(date).format('YYYY-MM-DD')
}

export function getDateFormattedFromTimestamp(timestamp: number, format = 'YYYY-MM-DD'): string {
    return moment(timestamp * 1000).format(format)
}